import { Link } from "react-router-dom";
import { useCategories } from "@/hooks/useMeta";
import { formatPrice, specDisplay } from "@/lib/api";
import { CompatBadge, VerifiedTick } from "@/components/common/Badges";
import { Checks } from "./CandidateList";

const NEEDS_ACTION = {
  incompatible: "Önceki seçimlerle artık uyumsuz — bu parçayı değiştirmeniz gerekiyor.",
  possible: "Uyumluluk doğrulanamadı veya sınırda — teknik ayrıntıları kontrol edin.",
};

/** Summary of all chosen parts with specs, compatibility and sellers of active listings. */
export default function BuildSummary({ evaluation, onGoto }) {
  const { data: cats = [] } = useCategories();
  if (!evaluation?.parts?.length) return <p className="text-sm text-zinc-500">Henüz parça seçilmedi.</p>;
  return (
    <div className="space-y-3" data-testid="build-summary">
      <div className="flex items-center gap-2"><span className="text-sm text-zinc-500">Genel durum:</span><CompatBadge status={evaluation.overall} testId="build-overall-status" /></div>
      {evaluation.parts.map((p) => {
        const cat = cats.find((c) => c.slug === p.step);
        const keys = cat?.fields.filter((f) => p.part.specs?.[f.key] !== undefined).slice(0, 6) || [];
        return (
          <div key={p.step} className={`panel p-4 ${p.status === "incompatible" ? "border-red-500/60" : ""}`} data-testid={`summary-${p.step}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <button onClick={() => onGoto(p.step)} className="text-left"><p className="eyebrow">{p.label}</p><p className="font-medium">{p.part.title}</p></button>
              <CompatBadge status={p.status} testId={`summary-status-${p.step}`} />
            </div>
            {NEEDS_ACTION[p.status] && <p className={`mt-1 text-xs ${p.status === "incompatible" ? "text-red-700" : "text-yellow-700"}`} data-testid={`summary-action-${p.step}`}>{NEEDS_ACTION[p.status]}</p>}
            <div className="mt-2"><Checks checks={p.checks} warnings={p.warnings} /></div>
            {keys.length > 0 && (
              <dl className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1 text-xs">
                {keys.map((f) => <div key={f.key} className="contents"><dt className="text-zinc-500">{f.label}</dt><dd className="font-mono">{specDisplay(f, p.part.specs[f.key])}</dd></div>)}
              </dl>
            )}
            {p.listings?.length > 0 && (
              <div className="mt-3 space-y-1 border-t border-black/[0.08] pt-2">
                <p className="text-xs text-zinc-500">Bu ürünü satanlar</p>
                {p.listings.map((l) => (
                  <Link key={l.listing_id} to={`/ilan/${l.listing_id}`} className="flex justify-between text-xs hover:text-[#0077ed]" data-testid={`summary-listing-${l.listing_id}`}>
                    <span>{l.seller.full_name} <VerifiedTick show={l.seller.is_verified_seller} /> · {l.province}</span><span className="font-mono">{formatPrice(l.price, l.currency)}</span>
                  </Link>
                ))}
              </div>
            )}
            {p.part.type === "listing" && <Link to={`/ilan/${p.part.id}`} className="mt-2 block text-xs text-[#0077ed]">İlana git ve satıcıya ulaş →</Link>}
          </div>
        );
      })}
    </div>
  );
}
